import { render, staticRenderFns } from "./SummaryInfo.vue?vue&type=template&id=10fc8566&scoped=true"
import script from "./SummaryInfo.vue?vue&type=script&lang=js"
export * from "./SummaryInfo.vue?vue&type=script&lang=js"
import style0 from "./SummaryInfo.vue?vue&type=style&index=0&id=10fc8566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fc8566",
  null
  
)

export default component.exports